"use client";

import {
	AlertTriangle,
	CheckCircle,
	CrossOctagon,
	Info,
	Loader2,
} from "@layer/icons";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "system" } = useTheme();

	return (
		<Sonner
			theme={theme as ToasterProps["theme"]}
			className="toaster group"
			icons={{
				success: <CheckCircle className="size-4" />,
				info: <Info className="size-4" />,
				warning: <AlertTriangle className="size-4" />,
				error: <CrossOctagon className="size-4" />,
				loading: <Loader2 className="size-4 animate-spin" />,
			}}
			style={
				{
					"--normal-bg": "var(--popover)",
					"--normal-text": "var(--popover-foreground)",
					"--normal-border": "var(--border)",
					"--border-radius": "var(--radius)",
				} as React.CSSProperties
			}
			{...props}
		/>
	);
};

export { Toaster };
